<div class="flex flex-col h-full">
  <div class="flex-grow min-h-0 overflow-auto">
    <div style="background-color: var(--p-primary-50);">
      <div class="p-4">
        <table>
          <tbody>
            @for (id of identifiers; track id.label) {
            <tr>
              <td><b><span style='margin-right: 40px;'>{{ id.label }}</span></b></td>
              <td>{{ id.description }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <h5 *ngIf="isAvailable">This {{entityType}} is available for Proximity Account Program use.</h5>
    <h5 *ngIf="!isAvailable">This {{entityType}} is <span style="color:red">NOT</span> available for Proximity Account
      Program
      use. See below.</h5>
    <div class="mt-4">
      <p-table [value]="availableStatuses" [tableStyle]="{ 'min-width': '30rem' }">
        <ng-template #header>
          <tr>
            <th></th>
            <th></th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template #body let-st>
          <tr>
            <td><b>{{ st.entityType }}</b></td>
            <td>{{ st.entityName }}</td>
            <td>
              <p-cellEditor>
                <ng-template #output>
                  <p-tag [value]="st.statusResult.baseStatusName"
                    [severity]="getSeverity(st.statusResult.baseStatusId)"
                    [styleClass]="getTagClass(st.statusResult.baseStatusId)" />
                </ng-template>
              </p-cellEditor>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="flex flex-shrink-0 mt-4 pb-2 items-center">
    <p-button (click)="onOk()" label="Ok" icon="pi pi-check" class="p-button-raised"></p-button>
    <div class="flex-grow"></div>
    <button (click)="onShowInsights()" pButton type="button" label="Insights" icon="fa-duotone fa-lightbulb"
      class="p-button-rounded qb-insights-button"
      pTooltip="Guide Me: Understanding product availability status" tooltipPosition="left"></button>
  </div>
</div>